var _polygon, _path, _path2, _path3, _rect, _path4, _path5, _rect2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoWithText(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513.48 110.17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "0 0 0 64.93 30.94 110.17 66.78 110.17 48.01 64.93 90.31 64.93 90.31 0 0 0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M257,179.56H243.21v24.69H225.77V126.34H257c15.69,0,27.43,11.63,27.43,26.66S272.65,179.56,257,179.56m-.77-36.76h-13v20.41h13c6.25,0,10.75-4.5,10.75-10.21s-4.5-10.2-10.75-10.2",
    transform: "translate(-90.31 -110.17)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M287.68,176.81a28.86,28.86,0,1,1,28.86,28.64,28.64,28.64,0,0,1-28.86-28.64m41,0c0-7.79-5.27-13.17-12.18-13.17s-12.18,5.38-12.18,13.17S309.63,190,316.54,190s12.18-5.38,12.18-13.17",
    transform: "translate(-90.31 -110.17)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M352.32,176.81c0-15.58,11.08-28.64,25.45-28.64,7.36,0,13.35,3.73,15.55,6.7V124.35h16.57v79.9H393.32v-7.09c-2.38,4.18-8.19,8.29-15.55,8.29-14.37,0-25.45-13.06-25.45-28.64m41.69,0c0-7.9-5-13.6-12.51-13.6s-12.5,5.7-12.5,13.6,5,13.61,12.5,13.61S394,184.71,394,176.81",
    transform: "translate(-90.31 -110.17)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 333.19,
    y: 39.21,
    width: 16.57,
    height: 54.87
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M453,180.65V149.38h16.57V177.8c0,8,2.31,12.62,8.45,12.62s10.32-4.28,10.32-14.38V149.38h16.56v54.87H488.35v-7.2c-2.44,5-7.47,8.4-14.6,8.4-13.61,0-20.74-9.87-20.74-24.8",
    transform: "translate(-90.31 -110.17)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M518.52,149.38h16.57v7.19a16.1,16.1,0,0,1,14-8.4c7.9,0,15.34,4,17.74,11.4a16.33,16.33,0,0,1,16-11.4c13.39,0,20.85,9.55,20.85,24.8v31.28H587.21V175.83c0-8-2.3-12.62-7.9-12.62-5.81,0-9.87,4.39-9.87,14.37v26.67H552.87V175.83c0-8-2.31-12.62-7.9-12.62-5.82,0-9.88,4.39-9.88,14.37v26.67H518.52Z",
    transform: "translate(-90.31 -110.17)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 333.08,
    y: 14.17,
    width: 16.68,
    height: 15.08
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWithText);
export default __webpack_public_path__ + "static/media/logo-with-text.3794f712c1894e156dcffc85db3c904e.svg";
export { ForwardRef as ReactComponent };